import React, { Fragment } from "react";
import { gql, useQuery } from "urql";
import { useQueryState } from "../../../components/src/use-query-state";
import { sortBy } from "lodash";

import { numberFormatFun } from "../../../common/src/utils/FormatFunctions";
import { Grid, Column } from "../../../components/src";
import { DateForm } from "../../../components/src/dateForm";
import { Page } from "../../../components/src/Page";
import { yesterday as yesterdayFnc } from "../../../components/src/dateFormater";

import { Link } from "wouter";

const getFundUnits = gql`
    query getFundUnits($date: GraphQLDateString) {
        fundUnits(date: $date) {
            instrumentId
            instrument {
                name
                isin
            }
            totalUnits
        }
    }
`;

const DataGrid = ({ date }) => {
    const [{ fetching, error, data }] = useQuery({ query: getFundUnits, variables: { date } });
    if (fetching)
        return (
            <Page>
                <div>
                    <div>Fetching fund units</div>
                    <div>Loading</div>
                </div>
            </Page>
        );
    if (error) return <div>`Error! ${error.message}`</div>;

    const fundUnits = sortBy(data.fundUnits, "instrument.name");

    return (
        <Fragment>
            <p>Number of fund classes: {fundUnits.length}</p>
            <Grid header="Fund Units" data={fundUnits} sortable tableClassName="table-xs">
                <Column
                    className="left"
                    field="instrumentId"
                    title="Fund class"
                    format={(_, item) => {
                        if (item.instrument && item.instrument.name) {
                            return (
                                <Link to={`/instruments/${item.instrumentId}`}>{item.instrument.name}</Link>
                            );
                        } else {
                            return "";
                        }
                    }}
                />
                <Column
                    className="left"
                    field="instrumentId"
                    title="Isin"
                    format={(_, item) => {
                        if (item.instrument && item.instrument.isin) {
                            return (
                                <Link to={`/instruments/${item.instrumentId}`}>{item.instrument.isin}</Link>
                            );
                        } else {
                            return "";
                        }
                    }}
                />
                <Column className="right" field="totalUnits" title="Total units" format={numberFormatFun("# ##0.#######")} />
            </Grid>
        </Fragment>
    );
};

export const PositionFundUnitsPage = (): React.ReactElement => {
    const yesterday = yesterdayFnc();
    const [date] = useQueryState("date", yesterday);
    return (
        <Fragment>
            <div className="flex flex-wrap -mx-2">
                <div className="w-full px-2 mb-4 flex">
                    <DateForm defaultDateString={date} dateName={"date"}></DateForm>
                </div>
            </div>
            <div className="flex flex-wrap -mx-2">
                <div className="w-full px-2 mb-4">
                    <DataGrid date={date} />
                </div>
            </div>
        </Fragment>
    );
};
